var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthGoogle = function SvgAuthGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M16.75 10.15a7.8 7.8 0 0 0-.105-1.26h-6.213v2.505h3.558a3.097 3.097 0 0 1-1.32 1.989v1.666h2.122c1.243-1.16 1.958-2.872 1.958-4.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.432 16.667c1.781 0 3.271-.6 4.36-1.617l-2.122-1.666c-.594.4-1.348.644-2.238.644-1.721 0-3.179-1.172-3.701-2.755H4.542v1.716c1.084 2.178 3.31 3.678 5.89 3.678Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.731 11.272A3.904 3.904 0 0 1 6.522 10c0-.444.077-.872.21-1.272V7.01h-2.19a6.645 6.645 0 0 0 0 5.978l2.19-1.717Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10.432 5.972c.973 0 1.842.34 2.53 1l1.88-1.9c-1.139-1.077-2.629-1.739-4.41-1.739-2.58 0-4.806 1.5-5.89 3.678l2.189 1.717c.522-1.583 1.98-2.756 3.7-2.756Z"
  })));
};
export default SvgAuthGoogle;